import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { Reveal } from "./Reveal";

const stats = [
    { value: 10000, suffix: "+", label: "Captains use RapidClick", testid: "stat-rides" },
    { value: 32, suffix: "ms", label: "Average click speed", testid: "stat-speed" },
    { value: 99, suffix: "%", label: "Success rate", testid: "stat-success" },
];

const Counter = ({ value, suffix, testid }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-15%" });
    const [n, setN] = useState(0);

    useEffect(() => {
        if (!inView) return;
        let raf;
        const start = performance.now();
        const dur = 1800;
        const tick = (t) => {
            const p = Math.min((t - start) / dur, 1);
            setN(Math.round(value * (1 - Math.pow(1 - p, 3))));
            if (p < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [inView, value]);

    return (
        <span
            ref={ref}
            data-testid={testid}
            className="font-mono text-5xl font-medium tracking-tight text-ink md:text-7xl"
        >
            {n.toLocaleString("en-IN")}
            <span className="text-brand">{suffix}</span>
        </span>
    );
};

export default function Stats() {
    return (
        <section id="stats" data-testid="stats-section" className="border-b border-line">
            <div className="mx-auto grid max-w-7xl grid-cols-1 divide-y divide-line md:grid-cols-3 md:divide-x md:divide-y-0">
                {stats.map((s, i) => (
                    <Reveal key={s.label} delay={i * 0.1} className="px-6 py-10 md:py-20 lg:px-12">
                        <Counter value={s.value} suffix={s.suffix} testid={s.testid} />
                        <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.18em] text-mute">
                            {s.label}
                        </p>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
